export const COPY_LINK_SUCCESS_MESSAGE = 'Link copied. League members who can sign in may open this archive.';
export const COPY_LINK_FAILURE_MESSAGE =
  'Could not copy link. You can copy the address from your browser bar.';

/** Copy text via the Clipboard API; returns false when unavailable or denied. */
export async function copyTextToClipboard(text: string): Promise<boolean> {
  const trimmed = text.trim();
  if (!trimmed) return false;
  try {
    if (typeof navigator !== 'undefined' && navigator.clipboard?.writeText) {
      await navigator.clipboard.writeText(trimmed);
      return true;
    }
  } catch {
    // Clipboard API blocked or unavailable.
  }
  return false;
}
